import styled from 'styled-components';

export const ContainerButtons = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    gap: 20px;
`;

export const Title = styled.h1`
    align-items: center;
    color: ${ ({ theme: { textColor } }) => textColor };
    display: flex;
    flex-direction: column;
    font-size: 1.4rem;
    font-weight: normal;
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: center;
    width: 100%;
`;

export const ModalContainer = styled.div`
    padding: 25px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
